import { render } from "./LayoutDefault.vue?vue&type=template&id=77ea8d4b&scoped=true"
import script from "./LayoutDefault.vue?vue&type=script&lang=js"
export * from "./LayoutDefault.vue?vue&type=script&lang=js"

import "./LayoutDefault.vue?vue&type=style&index=0&id=77ea8d4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77ea8d4b"],['__file',"src/apps/quiz/layouts/LayoutDefault.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77ea8d4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77ea8d4b', __exports__)) {
    api.reload('77ea8d4b', __exports__)
  }
  
  module.hot.accept("./LayoutDefault.vue?vue&type=template&id=77ea8d4b&scoped=true", () => {
    api.rerender('77ea8d4b', render)
  })

}


export default __exports__